import {
  LevelLayoutImageWithDims,
  LoadLevelLayoutImageDimensionsInput
} from 'utils/load-level-layout-image-dims-types';

export async function loadLevelLayoutImageDimensions({
  assignments,
  structureAttachments,
  cachedDimsByAttachmentId,
  loadDimensions
}: LoadLevelLayoutImageDimensionsInput): Promise<LevelLayoutImageWithDims[]> {
  const levelAssignments = Object.entries(assignments).filter(
    ([, assignment]) => assignment?.structureItemTypeCode === 'level'
  );

  const loaded = await Promise.all(
    levelAssignments.map(async ([id, assignment]) => {
      if (!assignment) {
        return null;
      }

      const attachmentId = Number(id);
      const cached = cachedDimsByAttachmentId?.[attachmentId];
      if (cached) {
        return {
          attachmentId,
          assignment,
          dims: cached,
          hasPose: assignment.scale != null
        };
      }

      const url = structureAttachments.find(
        (attachment) => attachment.id === attachmentId
      )?.url;
      if (!url) {
        return null;
      }

      const dims = await loadDimensions(url);
      if (!dims) {
        return null;
      }

      return {
        attachmentId,
        assignment,
        dims,
        hasPose: assignment.scale != null
      };
    })
  );

  return loaded.filter(
    (image): image is LevelLayoutImageWithDims => image !== null
  );
}
